module.exports = __webpack_public_path__ + "static/media/0030_IMG_LE_PRIMEUR.ebf8d298.png";